/**
 * @interface BorradoPermissions
 * @description Permisos del borrado controlado (FlujoBorrado, sección SSO `BorradoControlado`).
 */
export interface BorradoPermissions {
  /** Actividad `SolicitarBorradoCFDI`: el Operativo responsable pide borrar una factura con su materialidad. */
  canRequestDeleteInvoice: boolean;
  /** Actividad `AtenderSolicitudBorrado`: ve el apartado "Solicitudes de borrado" y aprueba o niega. */
  canAttendDeleteRequest: boolean;
}

/**
 * @function getBorradoPermissions
 * @description Calcula los permisos del borrado controlado.
 *
 * Como en el flujo de revisión, el rol Empresa atiende las solicitudes sin depender de la lista; el
 * Operativo, con la actividad asignada en su rol. Solicitar es exclusivo del Operativo (el back no deja
 * pedir al rol Empresa).
 *
 * @param {boolean} isEmpresa - El usuario tiene rol Empresa.
 * @param {boolean} isUser - El usuario tiene rol Operativo.
 * @param {(roleCheck: boolean, actionKey: string) => boolean} canPerformByRoleOrActionList - Helper de actividades.
 * @returns {BorradoPermissions} Permisos del borrado controlado.
 */
export const getBorradoPermissions = (
  isEmpresa: boolean,
  isUser: boolean,
  canPerformByRoleOrActionList: (roleCheck: boolean, actionKey: string) => boolean
): BorradoPermissions => ({
  canRequestDeleteInvoice: canPerformByRoleOrActionList(isUser, 'SolicitarBorradoCFDI'),
  canAttendDeleteRequest: isEmpresa || canPerformByRoleOrActionList(isUser, 'AtenderSolicitudBorrado'),
});
